module.exports = __webpack_public_path__ + "media/images/mobile/abouts/14-29704902ef2f179c4c8f232ab83ee95a.png";